import PropTypes from 'prop-types';
import { CatModal } from '@blocks-react/components/Modal';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import styles from './CSRPotentialIssueModalAssociatedDealer.module.scss';
import { useTranslation } from 'react-i18next';
import { replaceTokensInString } from '@app/utils';

const CSRPotentialIssueModalAssociatedDealer = ({
  isActive,
  onCancel,
  lastActiveDate,
  reasonCode
}) => {
  const [t] = useTranslation();
  return (
    <CatModal
      isActive={isActive}
      dismissible={false}
      disableBackdropClick={true}
      headingVariant="title-sm"
      heading={t('POTENTIAL_ACCOUNT_ISSUE')}
      size="md"
    >
      <div className={styles['CSRPOtentialIssueMessage']}>
        <span style={{ marginRight: '4px', marginTop: '-5px' }}>
          <CatIconWarningTriangle
            size="lg"
            color="error"
            slot="before"
            data-testid="error-icon"
          />
        </span>
        <CatTextPassage className={styles['CSRPotentialIssuemodalTextPassage']}>
          {reasonCode === 1
            ? t('CUSTOMER_ACCOUNT_WITHOUT_ASSOCIATED_DEALER').replace(
                '{0}',
                lastActiveDate || ''
              )
            : t('CUSTOMER_ACCOUNT_PENDING_DEALERS_APPROVAL').replace(
                '{0}',
                lastActiveDate || ''
              )}
        </CatTextPassage>
      </div>
      <CatButton onClick={onCancel} variant="primary" size="md">
        {t('UC_BACK')}
      </CatButton>
    </CatModal>
  );
};

CSRPotentialIssueModalAssociatedDealer.propTypes = {
  onCancel: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  lastActiveDate: PropTypes.string.isRequired
};

export default CSRPotentialIssueModalAssociatedDealer;
